import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { isApp } from 'services/environment';
import grantAwinConsent from 'services/awinConsent';

function AwinTracking() {
  const cookieConsent = useSelector(state => state.user.cookie_consent);

  useEffect(
    () => {
      if (isApp()) {
        return;
      }
      if (cookieConsent === 'dismissed' || cookieConsent === 'not_required') {
        grantAwinConsent();
      }
    },
    [cookieConsent],
  );

  return null;
}

export default AwinTracking;
